import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/app/shared/constants';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  authToken: any;
  user: any;
  role: any;
  permissions: any;
  sideBarMenu: any;

  constructor(private http: HttpClient,private route:Router) { }

  Baseurl(): string {
    return Constants.BASE_URL;
  }
  HrmsBaseurl(): string {
    return Constants.BASE_URL_HRMS;
  }
  getPendingInwardsCount(locationId): any { 
    return this.http.get<any>(this.Baseurl() + 'StockReports/GetBalanceOutwardsCountOnly/' + locationId);
  }
  getPendingInwards(locationId): any { 
    return this.http.get<any>(this.Baseurl() + 'StockReports/GetBalanceOutwards/' + locationId);
  }
  getPendingActions(){
    return this.http.get<any>(this.Baseurl() + 'Masters/GetPendingActions');
  }
  
  savePendingActions(postData) {
    return this.http.post<any>(this.Baseurl() + 'Masters/PostActionItem', postData, {observe: 'response'});
  }
  // Get the Locations
  getLocationCodes(): any {
    return this.http.get<any>(this.Baseurl() + 'Masters/GetAllLocationList');
  }

  getMenus(postData): any {
    return this.http.post<any>(this.Baseurl() + 'Masters/ValidateModule', postData, {observe: 'response'});
  }

  // Get the Finyears
  getFinancialYears(locationId): any { 
    return this.http.get<any>(this.Baseurl() + 'Masters/GetFinancialYear/' + locationId);
  }

  login(userData): any {
    return this.http.post<any>(this.Baseurl() + 'Masters/ValidateUserNew', userData, {observe: 'response'});
  }

  savePassword(inputData){
    return this.http.post<any>(this.Baseurl() + 'Masters/SavePassword', inputData, {observe: 'response'});
  }
  generateForgotPasswordOTP(inputData){
    return this.http.post<any>(this.Baseurl()+'Masters/GenerateForgotPassowrdOTP',inputData,{observe:'response'});
  }
  confirmForgotPasswordOTP(inputData){
    return this.http.post<any>(this.Baseurl()+'Masters/ConfirmForgotPasswordOTP',inputData,{observe:'response'});
  }
  sendDailyStatus(inputData): any {
    return this.http.post<any>(this.Baseurl() + 'SalesStatus/SendDailyStatus', inputData,{observe: 'response'});
  }
  sendReOrderNotification(inputData): any {
    return this.http.post<any>(this.Baseurl() + 'SalesStatus/SendReOrderNotification', inputData,{observe: 'response'});
  }
  makeActiveInactiveNotifications(inputData): any {
    return this.http.post<any>(this.Baseurl() + 'Masters/MakeNotificationsActiveOrInactive', inputData,{observe: 'response'});
  }
  /*Logout block starts*/
  updateLogoutStatus(userData): any {
    return this.http.post<any>(this.Baseurl() + 'Masters/Logout', userData, { observe: 'response' });
  }
  logout(): any {
    this.authToken = null;
    this.user = null;
    localStorage.clear();
    this.route.navigate(['/login']);
    return;
  }
  /*Logout block ends*/
  storeUserData(user: any): void {
    console.log(user);
    localStorage.setItem('token', user.AccessToken);
    localStorage.setItem('user', JSON.stringify(user));
    this.authToken = user.AccessToken;
    this.user = user;
  }

   public getKeyValue(keyname): string {
    try {
        const userStr = localStorage.getItem("user");
        if (!userStr) {
            return 'NoKey';
        }

        const userData = JSON.parse(userStr);
        if (userData?.Configuration && Array.isArray(userData.Configuration)) {
            const bucketEntry = userData.Configuration.find(item => item.KeyName === + keyname);
            return bucketEntry?.KeyValue;
        }

        return 'NoKey';
    } catch (error) {
        return 'NoKey';
    }
}

 hrmslogin(userData): any {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });
        const payload = {
            employeeCode: userData.employeeCode,
            password: userData.password,
            locationId: userData.locationId != null ? Number(userData.locationId) : 1,
            yearNo: userData.yearNo != null ? Number(userData.yearNo) : 7
        };
        return this.http.post<any>(this.HrmsBaseurl() + 'api/auth/login', payload, { headers, observe: 'response' });
  }

  storeHrmsData(user: any): void {
    localStorage.setItem('hrmstoken', user.token);
    localStorage.setItem('hrmsUser', JSON.stringify(user));
  }

  loadToken() {
    this.authToken = localStorage.getItem('token');
  }
  getToken(): string {
    return localStorage.getItem('token');
  }
  getUser(): any {
    return JSON.parse(localStorage.getItem('user'));
  }
  getSideMenu(): any {
    return JSON.parse(localStorage.getItem('user'));
  }
  changepassword(userObj): any {
    return this.http.post<any>(this.Baseurl() + 'ChangePassword', userObj);
  }
  
}
